module.exports = __webpack_public_path__ + "static/img/308_TO8_2294.e2126ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/308_TO8_2294.jpg
// module id = DzWs
// module chunks = 0